import React from "react";
import Button from "@mui/material/Button";

interface VehicleHeaderProps {
  name: string;
  isSmallScreen: boolean;
  onInfoClick: () => void;
}

const VehicleHeader: React.FC<VehicleHeaderProps> = ({
  name,
  isSmallScreen,
  onInfoClick,
}) => (
  <div className="flex items-center">
    <div
      className="box-border md:text-lg text-lg capitalize font-medium"
      style={{
        color: "#1E1E1E",
        fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
        marginTop: isSmallScreen ? "10%" : "15px",
        marginLeft: isSmallScreen ? "12.42px" : "25.42px",
        fontSize: "22px",
      }}
    >
      {name}
    </div>
    <div
      className="box-border md:text-lg text-lg capitalize"
      style={{ marginTop: isSmallScreen ? "10%" : "" }}
    >
      <Button onClick={onInfoClick}>
        <p
          className="text-md capitalize"
          style={{ color: "#0078D6", marginTop: isSmallScreen ? "" : "15px" }}
        >
          <img
            src="/assets/icons/Info_fill.png"
            className="h-[25px] w-[27px]"
            alt="icon"
          />
        </p>
      </Button>
    </div>
  </div>
);

export default VehicleHeader;
